import { render, staticRenderFns } from "./custom-card.vue?vue&type=template&id=a4165898&"
import script from "./custom-card.vue?vue&type=script&lang=js&"
export * from "./custom-card.vue?vue&type=script&lang=js&"
import style0 from "./custom-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports